function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Button from '../Buttons/Button/Button';
import ButtonLabel from '../Buttons/ButtonLabel/ButtonLabel';
import DrawerContainer from '../Drawer/DrawerContainer/DrawerContainer';
import DrawerContent from '../Drawer/DrawerContent/DrawerContent';
import DrawerFooter from '../Drawer/DrawerFooter/DrawerFooter';
import DrawerHeader from '../Drawer/DrawerHeader/DrawerHeader';
import DrawerTitle from '../Drawer/DrawerTitle/DrawerTitle';
import I18n from '../I18n/I18n/I18n';
import MetadataContext from '../MetadataContext/MetadataContext';
import NotificationSnackbarContext from '../NotificationSnackbar/NotificationSnackbarContext';
import RecordEditorDrawerEditor from './RecordEditorDrawerEditor';
import RecordEditorDrawerLoadingPlaceholder from './RecordEditorDrawerLoadingPlaceholder';
import Tooltip from '../Tips/Tooltip/Tooltip';
import fetcher from '../utils/http/fetcher';
import froalaConverter from '../utils/froalaConverter';
import getOr from '../utils/getOr';
import logger from '../utils/logger';
import uriTemplates from 'uri-templates';
import { injectIntl } from 'react-intl';
import { makeI18nKey } from './RecordEditorDrawer';
var getFormData = getOr({})('data');
var getSchema = getOr()('_embedded.schema');
var getUISchema = getOr()('_embedded.uiSchema');
var getRawFileMetadata = getOr()('_embedded.fileMetadata');
var getTriggers = getOr()('_embedded.triggers');
var getFileMetadata = function getFileMetadata(response) {
  var fileMetadata = getRawFileMetadata(response);
  return fileMetadata ? fileMetadata.map(function (file) {
    return {
      location: file.uri,
      size: file.contentLength,
      mimeType: file.contentType,
      name: file.fileName
    };
  }) : [];
};
var DEFAULT_RECORD = {};
var DEFAULT_RECORD_STATE = {
  closeOnSave: true,
  // close or add another after save
  focusFirstError: false,
  // true for first render after save validation failure
  state: 'loading',
  // 'loading' -> 'form-entry' -> 'save-requested' -> 'save-validated' -> 'saving'
  validateDirtyOnly: true // save clicked; false if validation failed to show all validation errors
};
function fillLink(href, context) {
  return uriTemplates(href).fill(context);
}
export default injectIntl(function RecordEditorDrawerContent(_ref) {
  var intl = _ref.intl,
    onClose = _ref.onClose,
    onSave = _ref.onSave,
    onError = _ref.onError,
    activitiesApi = _ref.activitiesApi,
    canAddAnother = _ref.canAddAnother,
    code = _ref.code,
    instrumentId = _ref.instrumentId,
    loggerName = _ref.loggerName,
    loggerProject = _ref.loggerProject,
    screenId = _ref.screenId,
    screenName = _ref.screenName,
    userId = _ref.userId,
    props = _objectWithoutProperties(_ref, ["intl", "onClose", "onSave", "onError", "activitiesApi", "canAddAnother", "code", "instrumentId", "loggerName", "loggerProject", "screenId", "screenName", "userId"]);
  var _useContext = useContext(NotificationSnackbarContext),
    notify = _useContext.notify;
  var _useState = useState(props.recordId),
    _useState2 = _slicedToArray(_useState, 2),
    recordId = _useState2[0],
    setRecordId = _useState2[1];
  var _useState3 = useState(DEFAULT_RECORD),
    _useState4 = _slicedToArray(_useState3, 2),
    record = _useState4[0],
    setRecord = _useState4[1];
  var _useState5 = useState(DEFAULT_RECORD_STATE),
    _useState6 = _slicedToArray(_useState5, 2),
    recordState = _useState6[0],
    setRecordState = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    formData = _useState8[0],
    setFormData = _useState8[1];
  var formRef = useRef();
  var isAdd = !recordId;
  var metadata = useContext(MetadataContext);
  var loggerData = useMemo(function () {
    return {
      instrumentId: instrumentId,
      isAdd: isAdd,
      isManagingData: userId !== metadata.userId,
      loginContext: metadata.loginContext,
      orgContext: metadata.orgContext,
      orgId: metadata.orgId,
      page: loggerProject,
      screenCode: code,
      screenId: screenId
    };
  }, [code, instrumentId, isAdd, metadata, screenId, userId]);
  useEffect(function () {
    logger(loggerName + 'Editor Open', loggerData);
    return function () {
      logger(loggerName + 'Editor Close', loggerData);
    };
  }, [loggerData]);

  // loading state
  useEffect(function () {
    if (recordState.state !== 'loading' || !activitiesApi || !screenId || !instrumentId || !userId) {
      return;
    }
    setRecord(DEFAULT_RECORD);
    setRecordState(DEFAULT_RECORD_STATE);
    var recordIds = {
      instrumentId: instrumentId,
      screenId: screenId,
      userId: userId,
      recordId: recordId
    };
    var recordUrl = fillLink(activitiesApi['_links'][isAdd ? 'activities:new-record' : 'activities:record'].href, recordIds);
    var fileUploadUrl = fillLink(activitiesApi['_links']['activities:records-upload-file'].href, recordIds);
    var recordsUrl = fillLink(activitiesApi['_links']['activities:records'].href, recordIds);
    fetcher(recordUrl).then(function (response) {
      var data = response.data;
      var formData = getFormData(data);
      setFormData(formData);
      setRecord({
        fileMetadata: getFileMetadata(data),
        fileUploadUrl: fileUploadUrl,
        formData: formData,
        schema: getSchema(data),
        triggers: getTriggers(data),
        uiSchema: getUISchema(data),
        recordsUrl: recordsUrl,
        recordUrl: recordUrl
      });
      setRecordState(_objectSpread({}, recordState, {
        state: 'form-entry'
      }));
    }).catch(function (error) {
      onError(makeI18nKey('error.load'));
      onClose();
    });
  }, [instrumentId, isAdd, onClose, onError, recordId, recordState, screenId, userId]);

  // form-entry state
  var handleSave = useCallback(function (closeOnSave) {
    if (recordState.state !== 'form-entry') {
      return;
    }
    setRecordState(_objectSpread({}, recordState, {
      state: 'save-requested',
      validateDirtyOnly: false,
      closeOnSave: closeOnSave
    }));
    setTimeout(function () {
      if (formRef && formRef.current) {
        formRef.current.submit();
      }
    }, 1);
  }, [recordState]);
  var handleSaveClose = useCallback(function () {
    return handleSave(true);
  }, [handleSave]);
  var handleSaveAdd = useCallback(function () {
    return handleSave(false);
  }, [handleSave]);

  // save-requested state
  var handleValidate = useCallback(function (valid) {
    if (recordState.state !== 'save-requested') {
      return;
    }
    setRecordState(_objectSpread({}, recordState, {
      focusFirstError: !valid,
      state: valid ? 'save-validated' : 'form-entry'
    }));
  }, [recordState]);
  useEffect(function () {
    if (recordState.focusFirstError) {
      setRecordState(_objectSpread({}, recordState, {
        focusFirstError: false
      }));
    }
  }, [recordState]);

  // save-validated state
  useEffect(function () {
    if (recordState.state !== 'save-validated') {
      return;
    }
    setRecordState(_objectSpread({}, recordState, {
      state: 'saving'
    }));
    fetcher(isAdd ? record.recordsUrl : record.recordUrl, {
      method: isAdd ? 'POST' : 'PUT',
      body: JSON.stringify({
        data: froalaConverter.fromFroala(formData, record.uiSchema || {}),
        instrumentId: instrumentId,
        screenId: screenId,
        userId: userId
      })
    }).then(function () {
      if (recordState.closeOnSave) {
        setRecordState(DEFAULT_RECORD_STATE);
        onClose();
      } else {
        // If adding new records we can re-use the new record template loaded
        if (isAdd) {
          setFormData(record.formData);
          setRecordState(_objectSpread({}, DEFAULT_RECORD_STATE, {
            state: 'form-entry'
          }));
        }
        // If editing a record we need to load up the new record template for add another
        else {
          setRecordId(null);
          setRecordState(DEFAULT_RECORD_STATE);
        }
      }
      onSave();
      notify({
        message: intl.formatMessage({
          id: makeI18nKey('success-notification')
        })
      });
      logger(loggerName + 'Editor Save', Object.assign({}, loggerData, {
        isAddAnother: !recordState.closeOnSave
      }));
    }).catch(function (error) {
      onError(makeI18nKey('error.load'));
      setRecordState(_objectSpread({}, recordState, {
        state: 'form-entry'
      }));
    });
  }, [formData, instrumentId, intl, isAdd, loggerData, loggerName, notify, onClose, onError, onSave, record, recordState, screenId, userId]);
  var titleI18n = useMemo(function () {
    return {
      id: isAdd ? makeI18nKey('add') : makeI18nKey('edit'),
      values: {
        screenName: screenName
      }
    };
  }, [isAdd, screenName]);
  return /*#__PURE__*/React.createElement(DrawerContainer, null, /*#__PURE__*/React.createElement(DrawerHeader, null, /*#__PURE__*/React.createElement(DrawerTitle, null, /*#__PURE__*/React.createElement(I18n, {
    i18n: titleI18n
  }))), recordState.state === 'loading' && /*#__PURE__*/React.createElement(DrawerContent, null, /*#__PURE__*/React.createElement(RecordEditorDrawerLoadingPlaceholder, null)), recordState.state !== 'loading' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerContent, null, /*#__PURE__*/React.createElement(RecordEditorDrawerEditor, {
    fileMetadata: record.fileMetadata,
    fileUploadUrl: record.fileUploadUrl,
    focusFirstError: recordState.focusFirstError,
    formData: formData,
    formRef: formRef,
    onChange: setFormData,
    onValidate: handleValidate,
    schema: record.schema,
    triggers: record.triggers,
    uiSchema: record.uiSchema,
    validateDirtyOnly: recordState.validateDirtyOnly
  })), /*#__PURE__*/React.createElement(DrawerFooter, null, /*#__PURE__*/React.createElement(Button, {
    disabled: recordState.state !== 'form-entry',
    onClick: onClose
  }, /*#__PURE__*/React.createElement(ButtonLabel, {
    i18nKey: makeI18nKey('cancel')
  })), canAddAnother && /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: makeI18nKey('saving'),
    neverShow: recordState.state === 'form-entry' || recordState.closeOnSave
  }, function (_ref2) {
    var ref = _ref2.ref,
      describedby = _ref2.describedby,
      events = _ref2.events;
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      "aria-describedby": describedby,
      disabled: recordState.state !== 'form-entry',
      onClick: handleSaveAdd,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: makeI18nKey('save-add')
    }));
  }), /*#__PURE__*/React.createElement(Tooltip, {
    i18nKey: makeI18nKey('saving'),
    neverShow: recordState.state === 'form-entry' || !recordState.closeOnSave
  }, function (_ref3) {
    var ref = _ref3.ref,
      describedby = _ref3.describedby,
      events = _ref3.events;
    return /*#__PURE__*/React.createElement(Button, Object.assign({
      "aria-describedby": describedby,
      disabled: recordState.state !== 'form-entry',
      modifier: 'primary',
      onClick: handleSaveClose,
      ref: ref
    }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
      i18nKey: makeI18nKey('save')
    }));
  }))));
});